import React from "react";
//import ReactDOM from 'react-dom';
import ReactDOM from 'react-dom/client';
import "./index.css";
import App from "./App";
import theme from "./App.theme"
import { ThemeProvider } from "@mui/material/styles"
// import * as serviceWorker from "./serviceWorker";

// React 17 and below render API
/*
ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
*/

// React 18 and above render API
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
    	<ThemeProvider theme={theme}>
      		<App />
    	</ThemeProvider>
	</React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
// serviceWorker.register();